import { useId, type ReactNode } from 'react';

import { Icon } from '../Icon.js';
import { useModalFocus } from '../../lib/useModalFocus.js';

/**
 * A PANEL FROM THE RIGHT, for one task at a time: inviting someone, changing a
 * role, sending a new link. Modal (focus stays inside, Escape and a click on the
 * backdrop close it, focus returns to whatever opened it), so the page behind it
 * keeps its own single primary action.
 */
export function SideDialog({
  title,
  onClose,
  testId,
  size = 'md',
  children,
}: {
  title: string;
  onClose: () => void;
  testId: string;
  /** `lg` for a panel that holds a list of its own (a bulk upload); full width on a phone either way. */
  size?: 'md' | 'lg';
  children: ReactNode;
}) {
  const modal = useModalFocus<HTMLDivElement>(onClose);
  const titleId = useId();

  return (
    <div
      className="team-dialog-backdrop"
      data-testid={testId}
      role="dialog"
      aria-modal="true"
      aria-labelledby={titleId}
      onKeyDown={modal.onKeyDown}
      onClick={(event) => {
        if (event.target === event.currentTarget) onClose();
      }}
    >
      <div className="team-dialog" data-size={size} ref={modal.ref}>
        <header className="team-dialog-head">
          <h3 id={titleId} className="team-dialog-title">
            {title}
          </h3>
          <button
            type="button"
            className="ctl team-dialog-close"
            aria-label="Close"
            data-testid={`${testId}-close`}
            onClick={onClose}
          >
            <Icon name="close" />
          </button>
        </header>
        <div className="team-dialog-body">{children}</div>
      </div>
    </div>
  );
}
